import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export type UserRole = 'admin' | 'moderator' | 'user';

export const useUserRole = () => {
  return useQuery({
    queryKey: ['user-role'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return null;

      const { data: roles } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', user.id);

      if (!roles || roles.length === 0) return 'user' as UserRole;

      // Return highest privilege role
      if (roles.some(r => r.role === 'admin')) return 'admin' as UserRole;
      if (roles.some(r => r.role === 'moderator')) return 'moderator' as UserRole;
      return 'user' as UserRole;
    },
  });
};

export const useIsModerator = () => {
  const { data: role } = useUserRole();
  return role === 'admin' || role === 'moderator';
};